import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Input } from "../../../../../core/components/atoms/Input";
import { usePrepareExercises } from "../../../hooks/prepareExercises";
import { practiceConfigStore } from "../../../stores/practiceConfigStore";
import { SectionContainer } from "../../../components/SectionContainer";
import { auxiliarStore } from "../../../stores/auxiliarStore";

export function QuestionQuantitySection({ setIsValidatingQuestions, availableQuestions }: { setIsValidatingQuestions: (value: boolean) => void, availableQuestions: number }) {
  const { mutate, data, isPending } = usePrepareExercises();
  const queryClient = useQueryClient();
  const {
    questionsNumber,
    questionsOrigin,
    areasFilter,
    setQuestionsNumber,
    setAreasFilter,
    setError,
    setDifficulty,
    setHasVideoResolution,
    setHasntDone,
    setSelectedYear,
    setInstitutionType,
  } = practiceConfigStore()
  const { areas } = auxiliarStore();

  const [errorMessage, setErrorMessage] = useState<string>('')
  const [hasError, setHasError] = useState<boolean>(false);

  const verifyQuestions = () => {
    const numericValue = Number(questionsNumber);
    if (questionsNumber === '' || numericValue < 5 || numericValue > 90) {
      resetFiltersAndRefetchInstitutions();
      return;
    }

    setIsValidatingQuestions(true);
    if(questionsOrigin === 'all' && areasFilter.length === 0) {
      const newArray = areas ? areas?.areas.map((it) => {
        return {
          area: it.id
        }
      }) : []

      setAreasFilter(newArray);
    }

    mutate();
  }

  const resetFiltersAndRefetchInstitutions = () => {
    setDifficulty([]);
    setHasVideoResolution(false);
    setHasntDone(false);
    setSelectedYear([]);
    setInstitutionType([]);
    setTimeout(() => {
      void queryClient.refetchQueries({ queryKey: ['fetch-exercises-institutions'] });
    }, 0);
  }

  useEffect(() => {
    if(Number(questionsNumber) < 5 && (questionsNumber !== undefined ||questionsNumber !== "")){
      setErrorMessage('A quantidade miníma de questões é 5.');
      setHasError(true)
    } else if(Number(questionsNumber) > 90) {
      setErrorMessage('O número máximo de questões é 90')
    } else {
      setErrorMessage('');
      setHasError(false)
    }
  }, [questionsNumber])

  useEffect(() => {
    setIsValidatingQuestions(false);
    if(data && data.exercisesQuantity < Number(questionsNumber)) {
      setError(true)
      setErrorMessage(`Com base nos filtros selecionados, é possível gerar um simulado de até ${data && data.exercisesQuantity} questões.`)
      setHasError(true);
    } else {
      setError(false)
      setErrorMessage('');
      setHasError(false)
    }
  }, [data])

  return (
    <SectionContainer title="Número total de questões">
      <Input
        type="number"
        label="Ex: 15"
        value={questionsNumber}
        onChange={(e) => setQuestionsNumber(e.target.value)}
        onBlur={() => verifyQuestions()}
        IconLeft={data && data.exercisesQuantity === Number(questionsNumber) && questionsNumber ? { type: 'material', Icon: 'done' } : undefined}
        error={hasError}
        errorMessage={errorMessage}
        helperText={availableQuestions ? `${availableQuestions} questões disponíveis para os filtros selecionados` : ''}
        loading={isPending}
      />
    </SectionContainer>
  )
}
